/* eslint-disable max-len */
import { Component, HostListener, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { MtmaModule } from 'src/app/model/mtma-module';
import { MtmaUnit } from 'src/app/model/mtma-unit';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MtmaTask } from 'src/app/model/mtma-task';
import { selectMtmaActiveTask, selectMtmaEditModule, selectMtmaModules, selectMtmaUnits } from 'src/app/store/device/device.selector';
import { MTMA_8C_LAYOUT_MTMF2P, MTMA_8C_LAYOUT_MTMF3P, MTMA_8C_LAYOUT_MTMF4P, MTMA_8C_LAYOUT_MTMF8P } from 'src/app/conf/mtma-module';
import { TranslateService } from '@ngx-translate/core';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-mtma-manage-module-8c',
	templateUrl: './mtma-manage-module-8c.component.html',
	animations: [],
})
export class MtmaManageModule8CComponent implements OnInit, OnDestroy, OnChanges {
	mtmaModules$: Observable<MtmaModule[] | undefined>;
	mtmaModulesSub: Subscription | undefined;
	mtmaActiveTask$: Observable<MtmaTask | undefined>;
	mtmaActiveTaskSub: Subscription | undefined;
	mtmaUnits$: Observable<MtmaUnit[] | undefined>;
	mtmaUnitsSub: Subscription | undefined;
	editModule$: Observable<boolean | undefined>;
	editModuleSub: Subscription | undefined;

	module: MtmaModule;

	moduleForm: FormGroup;
	listUnit: MtmaUnit[];
	filteredUnit1: MtmaUnit[];

	module8cList: MtmaModule[];
	layoutList: any;

	mtma8cLayoutDisable8P = [false, false, false, false, false, false, false, false];
	mtma8cLayoutDisable4P = [true, false, true, false, true, false, true, false];
	mtma8cLayoutDisable3P = [true, true, true, false, true, false, true, false];
	mtma8cLayoutDisable2P = [true, true, true, true, true, false, true, false];

	filterCtrlButton1 = new FormControl('');
	filteredUnitsButton1: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	filterCtrlButton2 = new FormControl('');
	filteredUnitsButton2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	filterCtrlButton3 = new FormControl('');
	filteredUnitsButton3: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	filterCtrlButton4 = new FormControl('');
	filteredUnitsButton4: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	filterCtrlButton5 = new FormControl('');
	filteredUnitsButton5: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	filterCtrlButton6 = new FormControl('');
	filteredUnitsButton6: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	filterCtrlButton7 = new FormControl('');
	filteredUnitsButton7: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	filterCtrlButton8 = new FormControl('');
	filteredUnitsButton8: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	upUnit: MtmaUnit;


	isActiveTask = false;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private formBuilder: FormBuilder,
		private dialogRef: DynamicDialogRef,
		public config: DynamicDialogConfig,
		private translate: TranslateService,
	) {
		if (this.config.data !== undefined && this.config.data.module !== undefined) {
			this.module = this.config.data.module;
		}
		this.initSelectors();
	}

	initSelectors(): void {
		this.mtmaModules$ = this.store.select(selectMtmaModules);
		this.mtmaActiveTask$ = this.store.select(selectMtmaActiveTask);
		this.mtmaUnits$ = this.store.select(selectMtmaUnits);
		this.editModule$ = this.store.select(selectMtmaEditModule);
	}

	ngOnInit(): void {
		this.upUnit = new MtmaUnit();
		this.upUnit.Name = this.translate.instant('BUTTON_NOT_SELECT');
		this.upUnit.ObjId = '000000000000000000000000';
		this.layoutList = [{ label: 'assets/images/mtma/mtm_black_1_0.svg', value: '0' },
		{ label: 'assets/images/mtma/mtm_black_1_1.svg', value: '1' },
		{ label: 'assets/images/mtma/mtm_black_1_2.svg', value: '2' },
		{ label: 'assets/images/mtma/mtm_black_1_3.svg', value: '3' }];

		this.dispatchGetUnits();
		this.mtmaUnitsSub = this.mtmaUnits$.pipe(
			filter((units) => !!units)
		).subscribe(units => {
			this.listUnit = units.slice();
			this.listUnit.unshift(this.upUnit);
			this.buildForm();
		});

		this.mtmaActiveTaskSub = this.mtmaActiveTask$.subscribe(mtmaActiveTask => {
			if (mtmaActiveTask.Id !== '') {
				this.isActiveTask = true;
			} else {
				this.isActiveTask = false;
			}
		});

		this.editModuleSub = this.editModule$.subscribe(editModule => {
			if (editModule) {
				this.closeDialog();
			}
		});
		this.mtmaModulesSub = this.mtmaModules$.subscribe(list => {
			this.module8cList = list.filter(item => item.Type === 1);
		});

		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	buildForm(): void {
		let button1 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[0]);
		let button2 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[1]);
		let button3 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[2]);
		let button4 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[3]);
		let button5 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[4]);
		let button6 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[5]);
		let button7 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[6]);
		let button8 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[7]);
		if (button1 === undefined) {
			button1 = this.upUnit;
		}
		if (button2 === undefined) {
			button2 = this.upUnit;
		}
		if (button3 === undefined) {
			button3 = this.upUnit;
		}
		if (button4 === undefined) {
			button4 = this.upUnit;
		}
		if (button5 === undefined) {
			button5 = this.upUnit;
		}
		if (button6 === undefined) {
			button6 = this.upUnit;
		}
		if (button7 === undefined) {
			button7 = this.upUnit;
		}
		if (button8 === undefined) {
			button8 = this.upUnit;
		}
		this.moduleForm = this.formBuilder.group({
			Name: [this.module.Name, [Validators.required, Validators.maxLength(48)]],
			Layout: [this.module.Config.Layout.toString()],
			Button1: [button1],
			Button2: [button2],
			Button3: [button3],
			Button4: [button4],
			Button5: [button5],
			Button6: [button6],
			Button7: [button7],
			Button8: [button8],
		});
	}

	ngOnChanges(): void {
		this.ngOnInit();
	}

	ngOnDestroy(): void {
		this.mtmaUnitsSub?.unsubscribe();
		this.mtmaActiveTaskSub?.unsubscribe();
		this.mtmaModulesSub?.unsubscribe();
		this.editModuleSub?.unsubscribe();
	}

	isButtonDisable(button: number): boolean {
		if (Number(this.f.Layout.value) === MTMA_8C_LAYOUT_MTMF8P) {
			return this.mtma8cLayoutDisable8P[button - 1];
		} else if (Number(this.f.Layout.value) === MTMA_8C_LAYOUT_MTMF4P) {
			return this.mtma8cLayoutDisable4P[button - 1];
		} else if (Number(this.f.Layout.value) === MTMA_8C_LAYOUT_MTMF3P) {
			return this.mtma8cLayoutDisable3P[button - 1];
		} else if (Number(this.f.Layout.value) === MTMA_8C_LAYOUT_MTMF2P) {
			return this.mtma8cLayoutDisable2P[button - 1];
		}
		return true;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.moduleForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.moduleForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		this.module = {
			...this.module,
			Name: this.f.Name.value,
		};
		this.module.Config.Layout = Number(this.f.Layout.value);
		this.module.Config.Buttons = [this.f.Button1.value.ObjId, this.f.Button2.value.ObjId, this.f.Button3.value.ObjId,
		this.f.Button4.value.ObjId, this.f.Button5.value.ObjId, this.f.Button6.value.ObjId,
		this.f.Button7.value.ObjId, this.f.Button8.value.ObjId];
		this.store.dispatch(DeviceActions.editMtmaModule({ module: this.module }));
	}

	dispatchGetUnits(): void {
		this.store.dispatch(DeviceActions.getMtmaUnits({}));
	}


	filterUnits(filterCtrlButton: FormControl, filteredUnitsButton: ReplaySubject<any[]>) {
		if (!this.listUnit) {
			return;
		}
		// get the search keyword
		let search = filterCtrlButton.value;
		if (!search) {
			filteredUnitsButton.next(this.listUnit.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		filteredUnitsButton.next(
			this.listUnit.filter(unit => unit.Name.toLowerCase().indexOf(search) > -1)
		);
	}

	getButtonNumber(btnNumber: number): number {
		let modulePos = 0;
		if (this.module8cList !== undefined && this.module8cList.length > 0) {
			for (const moduleScroll of this.module8cList) {
				if (moduleScroll.Position < this.module.Position) {
					modulePos++;
				}
			}
		}
		return 2 + (8 * modulePos) + btnNumber;
	}

	get f(): any {
		return this.moduleForm.controls;
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	onChangeLayout(): void {
		let button1 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[0]);
		let button2 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[1]);
		let button3 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[2]);
		let button4 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[3]);
		let button5 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[4]);
		let button6 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[5]);
		let button7 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[6]);
		let button8 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[7]);
		if (button1 === undefined) {
			button1 = this.upUnit;
		}
		if (button2 === undefined) {
			button2 = this.upUnit;
		}
		if (button3 === undefined) {
			button3 = this.upUnit;
		}
		if (button4 === undefined) {
			button4 = this.upUnit;
		}
		if (button5 === undefined) {
			button5 = this.upUnit;
		}
		if (button6 === undefined) {
			button6 = this.upUnit;
		}
		if (button7 === undefined) {
			button7 = this.upUnit;
		}
		if (button8 === undefined) {
			button8 = this.upUnit;
		}
		switch (Number(this.f.Layout.value)) {
			case MTMA_8C_LAYOUT_MTMF4P:
				this.f.Button1.setValue(this.listUnit[0]);
				this.f.Button3.setValue(this.listUnit[0]);
				this.f.Button5.setValue(this.listUnit[0]);
				this.f.Button7.setValue(this.listUnit[0]);
				this.f.Button2.setValue(button2);
				this.f.Button4.setValue(button4);
				this.f.Button6.setValue(button6);
				this.f.Button8.setValue(button8);
				this.f.Button1.disable();
				this.f.Button3.disable();
				this.f.Button5.disable();
				this.f.Button7.disable();
				this.f.Button2.enable();
				this.f.Button4.enable();
				this.f.Button6.enable();
				this.f.Button8.enable();
				break;
			case MTMA_8C_LAYOUT_MTMF3P:
				this.f.Button1.setValue(this.listUnit[0]);
				this.f.Button2.setValue(this.listUnit[0]);
				this.f.Button3.setValue(this.listUnit[0]);
				this.f.Button5.setValue(this.listUnit[0]);
				this.f.Button7.setValue(this.listUnit[0]);
				this.f.Button4.setValue(button4);
				this.f.Button6.setValue(button6);
				this.f.Button8.setValue(button8);
				this.f.Button1.disable();
				this.f.Button2.disable();
				this.f.Button3.disable();
				this.f.Button5.disable();
				this.f.Button7.disable();
				this.f.Button4.enable();
				this.f.Button6.enable();
				this.f.Button8.enable();
				break;
			case MTMA_8C_LAYOUT_MTMF2P:
				this.f.Button1.setValue(this.listUnit[0]);
				this.f.Button2.setValue(this.listUnit[0]);
				this.f.Button3.setValue(this.listUnit[0]);
				this.f.Button4.setValue(this.listUnit[0]);
				this.f.Button5.setValue(this.listUnit[0]);
				this.f.Button7.setValue(this.listUnit[0]);
				this.f.Button6.setValue(button6);
				this.f.Button8.setValue(button8);
				this.f.Button1.disable();
				this.f.Button2.disable();
				this.f.Button3.disable();
				this.f.Button4.disable();
				this.f.Button5.disable();
				this.f.Button7.disable();
				this.f.Button6.enable();
				this.f.Button8.enable();
				break;
			default:
				this.f.Button1.setValue(button1);
				this.f.Button2.setValue(button2);
				this.f.Button3.setValue(button3);
				this.f.Button4.setValue(button4);
				this.f.Button5.setValue(button5);
				this.f.Button6.setValue(button6);
				this.f.Button7.setValue(button7);
				this.f.Button8.setValue(button8);
				this.f.Button1.enable();
				this.f.Button2.enable();
				this.f.Button3.enable();
				this.f.Button4.enable();
				this.f.Button5.enable();
				this.f.Button6.enable();
				this.f.Button7.enable();
				this.f.Button8.enable();
		}
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	justifyMessagesNewValidator(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: MtmaManageModule8CComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	dynamicAutocomplete(): string {
		return StandardDynamicComponent.dynamicAutocomplete(this.screenWidth);
	}

	dynamicBorderLabelMobile(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: MtmaManageModule8CComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

}

